
import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { StatusBar } from '@ionic-native/status-bar';

import { Storage } from '@ionic/storage';

import { ConsumerMainPage } from '../../pages/consumer-main/consumer-main';
import { BusinessRegisterPage } from '../../pages/business-register/business-register';
import { RegisterTermsPage } from '../../pages/register-terms/register-terms';

import { LoginPage } from '../../pages/login/login';
import { AuthProvider } from '../../providers/auth';

@Component({
  selector: 'page-register',
  templateUrl: 'register.html',
})
export class RegisterPage {
	registerForm : FormGroup;
	isRegistering: boolean = false;
	recievedError: boolean = false;
	errorText: any;

	constructor(
		public statusBar: StatusBar, 
		public navCtrl: NavController, 
		public storage: Storage,
		public authProvider: AuthProvider,  	
		public navParams: NavParams,
		public formBuilder: FormBuilder,) {
		this.registerForm = this.formBuilder.group({
			"FullName":  ['', Validators.compose([Validators.required, Validators.minLength(5)]) ],			
		  	"Email":  ['', Validators.compose([Validators.required, Validators.email])],
		  	"Password":  ['', Validators.compose([Validators.required, Validators.minLength(6)]) ],  
		});
	}

	ionViewCanLeave(): boolean{
		if(this.isRegistering){
			return false;
		}else{
			return true;
		}
	}	

	register(){
	    if(this.isRegistering) return;

	    this.isRegistering = true;
	    this.recievedError = false;

	    this.authProvider.register(this.registerForm.value)
	    .then( data => {
	        
	        this.login();

	    })
	    .catch( error => {
	        this.isRegistering = false;
	        this.recievedError = true;

	        if(error.json().ModelState.BadEmail){
	        	this.errorText = error.json().ModelState.BadEmail[0];
	        }else{
	        	this.errorText = error.json().Message;
	        }
	        
	        console.log(error)
	    })
	}

	moveToLogin(){	
		this.navCtrl.push(LoginPage);
	}

	moveToRegisterBusiness(){
		this.navCtrl.push(BusinessRegisterPage);
	}

	viewTerms(){
		this.navCtrl.push(RegisterTermsPage);
	}

	login(){
		let body = {
			"grant_type": 'password',
			"username":  this.registerForm.value.Email,
			"password":  this.registerForm.value.Password,
		};

	    this.authProvider.login(body)
	    .then( data => {        
	    	this.isRegistering = false;

            this.navCtrl.setRoot(ConsumerMainPage);            
	    })
	    .catch( error => {
	        this.isRegistering = false;
	        this.recievedError = true;

	        console.log(error)
	    })

	}
}



// WEBPACK FOOTER //
// ./src/pages/register/register.ts